// extracted by mini-css-extract-plugin
export default {"container":"container--6pT7q","text-container":"text-container--2Wydz","main-text":"main-text--35bWJ","sub-text":"sub-text--IKG5N"};